<template>
  <swiper :banners="banners"></swiper>
</template>

<script>
import swiper from "../components/swiper.vue"
import about1 from "../assets/img/about1.png";
import about2 from "../assets/img/about2.png";
import about3 from "../assets/img/about3.png";
import about4 from "../assets/img/about4.png";
import about5 from "../assets/img/about5.png";
export default {
  data() {
    return {
      banners: [about1, about2, about3, about4, about5],
    };
  },
  components: {
    swiper
  },  
};
</script>

